import { render } from "./LiteFeatureLock.vue?vue&type=template&id=ece12a80&scoped=true"
import script from "./LiteFeatureLock.vue?vue&type=script&lang=js"
export * from "./LiteFeatureLock.vue?vue&type=script&lang=js"

import "./LiteFeatureLock.vue?vue&type=style&index=0&id=ece12a80&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece12a80"]])

export default __exports__